import { pathOr, datetimeFormat } from '../helpers';
import { PRODUCT_IMPORT_HISTORY_STATUSES } from '../../../enums/productImportHistory';

export const transformedProductImportHistory = (productImportHistory = {}) => {
	const filename = pathOr('', ['name'])(productImportHistory);
	const originalUrl = pathOr('', ['original_url'])(productImportHistory);
	const file = { name: filename, url: originalUrl };
	const type = pathOr('', ['type'])(productImportHistory);
	const firstName = pathOr(null, ['user', 'profile', 'first_name'])(productImportHistory);
	const lastName = pathOr(null, ['user', 'profile', 'last_name'])(productImportHistory);
	const username = pathOr(null, ['user', 'username'])(productImportHistory);
	const uploader = firstName && lastName ? `${firstName} ${lastName}` : username;
	const createdAt = productImportHistory.created_at ? datetimeFormat(productImportHistory.created_at) : '-';
	const status = PRODUCT_IMPORT_HISTORY_STATUSES[productImportHistory.status];
	const logfile = productImportHistory.status === 'failed'
		? pathOr('', ['log_url'])(productImportHistory)
		: '';

	return {
		file,
		type,
		logfile,
		uploader,
		createdAt,
		status,
	};
};

export const transformedProductImportHistoryList = (productImportHistories = []) => {
	const data = productImportHistories.map((productImportHistory) => transformedProductImportHistory(productImportHistory));
	return data;
};
